import * as React from 'react';

import Pagination from 'react-js-pagination';

import './Paginator.scss';
import i18n from 'src/translation/i18n';

interface IPaginatorProps {
  activePage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChanged(event: any): void;
}

class Paginator extends React.Component<IPaginatorProps, any> {
  public render() {
    return this.props.totalPages !== 0 ? (
      <div className="rp-paginator">
        <Pagination
          activePage={this.props.activePage}
          totalItemsCount={this.props.totalItems}
          itemsCountPerPage={this.props.itemsPerPage}
          pageRangeDisplayed={3}
          firstPageText={`${i18n.t('pagination.first')}`}
          lastPageText={`${i18n.t('pagination.last')}`}
          onChange={this.props.onPageChanged}
        />
      </div>
    ) : (
      <span />
    );
  }
}

export default Paginator;
